import React, {useState, useEffect} from "react";
import MovieModal from "./movieModal"
//import { isArray } from "util"
import imdbLogo from "./assets/images/imdb.png"
import ActorInfo from "./components/actorInfo"
import WatchInfo from "./components/watchInfo"
import SaveButton from './utils/saveButton'

export default function MovieCard({movie}) {
    const [details, setDetails] = useState([])
    const [cast, setCast] = useState([])
    const [crew, setCrew] = useState([])
    const [similars, setSimilars] = useState([])
    const [recommendations, setRecommendations] = useState([])

    const TMDB_KEY = process.env.REACT_APP_TMDB_KEY || "";

    const dispDate = movie.release_date !== "" ? new Date(movie.release_date) : null

    const getDetails = async () => {
        const url = `https://api.themoviedb.org/3/movie/${movie.id}?api_key=${TMDB_KEY}&language=en-US`;
        const res = await fetch(url);
        const data  = await res.json(); 
        setDetails(data)    
    }

    const getCast = async () => {
        const url = `https://api.themoviedb.org/3/movie/${movie.id}/credits?api_key=${TMDB_KEY}&language=en-US`
        const res = await fetch(url);
        const data  = await res.json(); 
        setCast(data.cast)
        setCrew(data.crew)
    }

    const getSimilars = async () => {
        const url = `https://api.themoviedb.org/3/movie/${movie.id}/similar?api_key=${TMDB_KEY}&language=en-US`
        const res = await fetch(url);
        const data  = await res.json(); 
        setSimilars(data)
    }    

    const getRecommendations = async () => {
        const url = `https://api.themoviedb.org/3/movie/${movie.id}/recommendations?api_key=${TMDB_KEY}&language=en-US`
        const res = await fetch(url);
        const data  = await res.json(); 
        setRecommendations(data)
    } 

    // const style = {  
    //     //backgroundImage: `url("https://image.tmdb.org/t/p/w1920_and_h800_multi_faces/${details.backdrop_path}")`,
    //     backgroundPosition: 'center',
    //     backgroundSize: 'cover',
    //     backgroundRepeat: 'no-repeat'
    // }    
    const posterPath = details.poster_path || movie.poster_path
    const leftStyle = {
        width: '100%',
        height: '201px',
        // marginRight: '16px',
        backgroundImage: posterPath ? `url("https://image.tmdb.org/t/p/w342${posterPath}")` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        borderRadius: '4px'
    }

    const rightStyle = {  
        width: posterPath ? '60%' : '40%',
        paddingLeft: '10px'
    }
    // eslint-disable-next-line  
    useEffect(() => {
        getDetails()
        getCast()
        getSimilars()
        getRecommendations()
        // eslint-disable-next-line
    }, [])      


    return (
        <div className="card">
            <table>
                <tbody>
                <tr>
                    <td width="20%" valign="top" className="poster">
                        {details.status !== 'Released' ? <small className="upComing">Not Yet Released</small> : null}
                    </td>
                    <td>
                        <div className="card--content" key={movie.id} style={{overflow: 'hidden'}}>
                            <h3 className="card--title">
                                {movie.title} {dispDate !== null ? `(${dispDate.getFullYear()})` : null}
                            </h3>
                            <div style={{display:'flex'}}>
                                <div style={{width:'40%', float:'left', display:'flex', flexDirection:'column', alignItems:'center'}}>
                                    <div style={leftStyle} aria-hidden={!posterPath} />
                                    {details.imdb_id ? (
                                        <a href={`https://imdb.com/title/${details.imdb_id}`} rel="noopener noreferrer" target="_blank" style={{marginTop:8}}>
                                            <img src={imdbLogo} className="imdb-logo" alt="IMDb" title="Go to IMDb" style={{width:60}} />
                                        </a>
                                    ) : null}
                                    <div style={{marginTop:8, display:'flex', justifyContent:'center'}}>
                                        <SaveButton movie={movie} />
                                    </div>
                                </div>
                            
                            <div className="" style={rightStyle}>
                                <div className="">
                                    <small>RELEASE DATE: {movie.release_date ? movie.release_date : "In Production"}</small>
                                </div>
                                <div className="">
                                    <small>
                                        GENRE(S):&nbsp;
                                        {Array.isArray(details.genres) ? details.genres.map(genre => (<li key={genre.id}>{genre.name}</li>)) : ""}
                                    </small>
                                </div>
                                <div className="">
                                    <small>
                                    DIRECTOR:
                                    {crew.filter(person => person.job === 'Director').map(person => (
                                       <li key={person.id}>&nbsp;<a href={`/people/${person.name}`}>{person.name}</a></li>
                                    ))}
                                    </small>
                                </div>
                                <div className="">
                                    <small>
                                    SCREENPLAY:
                                    {crew.filter(person => person.job === 'Screenplay').map(person => (
                                       <li key={person.id}>&nbsp;<a href={`/people/${person.name}`}>{person.name}</a></li>
                                    ))}
                                    </small>
                                </div>                                 
                                <div className="">
                                    <small>
                                    RUNTIME: {details.runtime ? `${details.runtime} mins` : "TBD"}
                                    </small>
                                </div>                                
                                <div className="">
                                    <small>
                                        RATING: {movie.vote_average ? `${movie.vote_average} out of 10` : "TBD"}
                                    </small>
                                </div>
                                </div>
                            </div>

                            <p className="card--desc" style={{marginTop:"20px"}}>{movie.overview}</p>

                            <WatchInfo movie={movie} source="movie" />

                            <ActorInfo cast={cast} />
                            
                            <MovieModal details={details} similars={similars} recommendations={recommendations} />
                        </div>
                    </td>
                </tr>
                </tbody>
            </table> 
        </div>
    )
}
